<template>
    <el-dialog title="Désactivé syncro stock" v-loading="loader" :visible.sync="display" width="50%">
        <span>Désactivé la syncro de stock pour les {{ items_selected }} produits selectionnés</span>
        <div class="row">
            <div class="col-lg-12">
                <el-form class="formIndex" ref="form" :model="form">
                    <el-form-item prop="sync_stock" label="Syncro le stock ?">
                        <el-switch v-model="form.sync_stock" active-text="Oui" inactive-text="Non">
                        </el-switch>
                    </el-form-item>
                    <el-form-item prop="resetStock" label="Forcer le stock à 0 ?">
                        <el-switch v-model="form.resetStock" active-text="Oui" inactive-text="Non">
                        </el-switch>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        
        <span slot="footer" class="dialog-footer">
            <el-button @click="display = false">Annuler</el-button>
            <el-button type="primary" @click="action">Enregistrer</el-button>
        </span>
    </el-dialog>
</template>
<script>
export default {
    data() {
        return {
            display: false,
            loader: false,
            form: {
                resetStock: false,
                sync_stock: false
            }
        };
    },
    props: {
        applyToAllResult: {
            default: false
        },
        filters: {
            default: null
        },
        selected: {
            default: []
        },
        total_item: {
            default: 0
        }
    },
    computed: {
        items_selected() {
            return this.applyToAllResult
                ? this.total_item
                : this.selected.length;
        }
    },
    methods: {
        open() {
            this.display = true;
            this.$store.dispatch('products/setLoader', false);
        },
        action() {
            var resetStock = this.form.resetStock;
            var sync_stock = this.form.sync_stock;
            var products = this.selected.map(v => v.id);
            this.loader = true;
            var datas = {
                products,
                resetStock,
                sync_stock,
                mode: 'desactivate_stock'
            };
            if (this.applyToAllResult) {
                datas.filters = this.filters;
            }
            datas.total_item = this.total_item
            datas.items_selected = this.items_selected
            axios
                .post('/products/bulk', datas)
                .then(r => {
                    this.$emit('saved', r);
                    this.$refs.form.resetFields();
                    this.display = false;
                })
                .catch(() => {})
                .then(() => {
                    this.loader = false;
                });
        }
    }
};
</script>
